import baseballNormalMarker from "./markers/BaseballNormalMarker.svg";
import baseballWarningMarker from "./markers/BaseballWarningMarker.svg";
import baseballCriticalMarker from "./markers/BaseballCriticalMarker.svg";
import baseballUnknownMarker from "./markers/BaseballUnknownMarker.svg";

import golfNormalMarker from "./markers/GolfNormalMarker.svg";
import golfWarningMarker from "./markers/GolfWarningMarker.svg";
import golfCriticalMarker from "./markers/GolfCriticalMarker.svg";
import golfUnknownMarker from "./markers/GolfUnknownMarker.svg";

import broadcastNormalMarker from "./markers/BroadcastNormalMarker.svg";
import broadcastWarningMarker from "./markers/BroadcastWarningMarker.svg";
import broadcastCriticalMarker from "./markers/BroadcastCriticalMarker.svg";
import broadcastUnknownMarker from "./markers/BroadcastUnknownMarker.svg";

import softballNormalMarker from "./markers/SoftballNormalMarker.svg";
import softballWarningMarker from "./markers/SoftballWarningMarker.svg";
import softballCriticalMarker from "./markers/SoftballCriticalMarker.svg";
import softballUnknownMarker from "./markers/SoftballUnknownMarker.svg";
import { MarkerSeverity, MarkerType } from "../enums";

export interface IMarkerStatusIcons {
  normal: string;
  warning: string;
  critical: string;
  unknown: string;
}

const toolbarIconLibrary: {
  systems: {
    baseball: IMarkerStatusIcons;
    golf: IMarkerStatusIcons;
    broadcast: IMarkerStatusIcons;
    softball: IMarkerStatusIcons;
  };
} = {
  systems: {
    baseball: {
      normal: baseballNormalMarker,
      warning: baseballWarningMarker,
      critical: baseballCriticalMarker,
      unknown: baseballUnknownMarker,
    },
    golf: {
      normal: golfNormalMarker,
      warning: golfWarningMarker,
      critical: golfCriticalMarker,
      unknown: golfUnknownMarker,
    },
    broadcast: {
      normal: broadcastNormalMarker,
      warning: broadcastWarningMarker,
      critical: broadcastCriticalMarker,
      unknown: broadcastUnknownMarker,
    },
    softball: {
      normal: softballNormalMarker,
      warning: softballWarningMarker,
      critical: softballCriticalMarker,
      unknown: softballUnknownMarker,
    },
  },
};

// Gets the svg for each marker corrosponding to the type of the marker
export const getMarkerIcon = (
  markerStatus: MarkerSeverity,
  markerType: MarkerType
) => {
  const defaultMarkerIcons: IMarkerStatusIcons =
    toolbarIconLibrary.systems.baseball;
  var markerIcons: IMarkerStatusIcons;

  switch (markerType) {
    case MarkerType.BASEBALL:
      markerIcons = toolbarIconLibrary.systems.baseball;
      break;
    case MarkerType.GOLF:
      markerIcons = toolbarIconLibrary.systems.golf;
      break;
    case MarkerType.GOLF_BROADCAST:
      markerIcons = toolbarIconLibrary.systems.broadcast;
      break;
    case MarkerType.SOFTBALL:
      markerIcons = toolbarIconLibrary.systems.softball;
      break;
    case MarkerType.UNKNOWN:
    default:
      markerIcons = defaultMarkerIcons;
      break;
  }

  switch (markerStatus) {
    case MarkerSeverity.Critical:
      return markerIcons.critical;
    case MarkerSeverity.Warning:
      return markerIcons.warning;
    case MarkerSeverity.Normal:
      return markerIcons.normal;
    case MarkerSeverity.Unknown:
      return markerIcons.unknown;
    default:
      return "";
  }
};

export default toolbarIconLibrary;
